import FormatCurrency from 'components/Common/FormatCurrency'
import Plural from 'components/utils/Formatters/Plural'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import React from 'react'

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum',
}

interface Props {
  ratio: number;
  className?: string;
}

function LoyaltyPointsEarnRatio(props: Props) {
  const { ratio, className } = props

  const [tier] = useCurrentLoyaltyTier()

  return <BodyTextBlock
    variant="small"
    colour={TIER_BODY_TEXT_COLOURS[tier]}
    startIcon={<LoyaltyTierIcon size="S" tier={tier} />}
    weight="bold"
    className={className}
  >
    Earn <Plural count={ratio} singular="pt" withCount /> per <FormatCurrency value={1} />
  </BodyTextBlock>
}

export default LoyaltyPointsEarnRatio
